"use client";

import { Suspense, useRef } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import { useGLTF, OrbitControls, Stage } from "@react-three/drei";
import * as THREE from "three";

function Model({ url }: { url: string }) {
  const { scene } = useGLTF(url);
  const modelRef = useRef<THREE.Group>(null);

  useFrame((state: any) => {
    if (!modelRef.current) return;

    // Follow mouse (Horizontal & Vertical)
    const targetRotationX = state.mouse.y * -0.5; // Increased for better top/bottom tracking
    const targetRotationY = state.mouse.x * 0.6;

    modelRef.current.rotation.x = THREE.MathUtils.lerp(
      modelRef.current.rotation.x,
      targetRotationX,
      0.08,
    );
    modelRef.current.rotation.y = THREE.MathUtils.lerp(
      modelRef.current.rotation.y,
      targetRotationY,
      0.08,
    );

    // Subtle Floating effect (Reduced bounciness)
    const time = state.clock.getElapsedTime();
    modelRef.current.position.y = Math.sin(time * 1.5) * 0.08;
  });

  return <primitive ref={modelRef} object={scene} scale={0.5} />;
}

export function RobotModel({ className }: { className?: string }) {
  return (
    <div className={className} style={{ width: "100%", height: "100%" }}>
      <Canvas shadows camera={{ position: [0, 0, 5], fov: 40 }}>
        <Suspense fallback={null}>
          <Stage environment={null} intensity={1.9}>
            <Model url="/images/Meshy_AI_Waving_Blue_Robot_0305062502_texture.glb" />
          </Stage>
        </Suspense>
        <OrbitControls enableZoom={false} enablePan={false} />
      </Canvas>
    </div>
  );
}
